import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import Report from 'components_new/pages/Report'
import ReportEdition from 'components_new/pages/ReportEdition'
import ReportEditions from 'components_new/pages/ReportEditions'
import ReportSettings from 'components_new/pages/ReportSettings'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <ReportEdition />}
        path={'/reports/:id/editions/:edition_id'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <ReportEditions />}
        path={'/reports/:id/editions'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <ReportSettings />}
        path={'/reports/:id/settings'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Report />}
        path={'/reports/:id'}
      />
      <Route path={'/reports/*'}>
        <Redirect to="/resources" />
      </Route>
    </Switch>
  )
}

export default Routes
